import React, { Component } from "react";
import "./PlanSuggestion.css";
import PlanSuggestionQuestionSingleSelect from "./PlanSuggestionQuestionSingleSelect";
import PlanSuggestionQuestionSingleSlider from "./PlanSuggestionQuestionSingleSlider";
import PlanSuggestionQuestionDataUse from "./PlanSuggestionQuestionDataUse";
import PlanSuggestionOffers from "./PlanSuggestionOffers";

class PlanSuggestion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // status: "showingOffers",
      // answers: {'question-data-use-monthly': 0},

      status: "answering",
      answers: {},
      currentQuestionKey: null,
      questions: {
        "question-data-use-monthly": {
          type: "single-select",
          data: {
            headerTc: "",
            headerEn: "",
            questionTc: "你每月大概用幾多數據？",
            questionEn: "How much data do you need?",
            trackingIdBack: "S2_back",
            trackingIdNext: "S2_next",
            options: [
              {
                labelTc: "少於20GB",
                labelEn: "Less than 20GB",
                trackingId: "S2_DU20",
              },
              {
                labelTc: "21GB-50GB",
                labelEn: "21GB-50GB",
                trackingId: "S2_DU21-50",
              },
              {
                labelTc: "多於50GB",
                labelEn: "More than 50GB",
                trackingId: "S2_DU50",
              },
              {
                labelTc: "不知道",
                labelEn: "I am not sure",
                trackingId: "S2_DUDK",
              },
            ],
          },
        },
        "question-travel-cnmo": {
          type: "single-slide",
          data: {
            headerTc: "只差一步",
            headerEn: "Just one step away",
            questionTc: "你每月平均會去內地或澳門幾多次？​",
            questionEn:
              "How often do you travel to mainland China or Macau per month?",
            trackingIdBack: "S4_back",
            trackingIdNext: "S4_next",
            options: [
              {
                labelTc: "0次",
                labelEn: "No",
                trackingId: "S4_T0",
              },
              {
                labelTc: "1-2次",
                labelEn: "1-2 times",
                trackingId: "S4_T1-2",
              },
              {
                labelTc: "3-4次",
                labelEn: "3-4 times",
                trackingId: "S4_T3-4",
              },
              {
                labelTc: "多於5次",
                labelEn: "5 times or more",
                trackingId: "S4_T5",
              },
            ],
          },
        },
        "question-data-use-monthly-calculate": {
          type: "data-use",
          data: {
            headerTc: "唔緊要，等我哋幫你計",
            headerEn: "No Problem, let’s work it out",
            questionTc: "你每日平均花幾多時間於以下活動?",
            questionEn:
              "Roughly how much time do you spend on the following activities each day?",
            questionRemarkTc: "（非使用Wi-Fi的情況下）",
            questionRemarkEn:
              "Please exclude any time that you stay connected to Wi-Fi.",
            trackingIdBack: "S3_back",
            trackingIdNext: "S3_next",
          },
        },
      },
    };
  }

  showLoadingOffers() {
    this.setState({ status: "loading" }, () => {
      setTimeout(() => {
        this.showSuggestedOffers();
      }, 1000);
    });
  }

  showSuggestedOffers() {
    this.setState({ status: "showingOffers" });
  }

  handleQuestionBack() {
    const { currentQuestionKey, answers } = this.state;
    switch (currentQuestionKey) {
      case "question-data-use-monthly":
        this.setState({
          status: "answering",
          answers: {},
          currentQuestionKey: null,
        });
        break;
      case "question-travel-cnmo":
        if (answers["question-data-use-monthly-calculate"] != null) {
          this.setState({
            currentQuestionKey: "question-data-use-monthly-calculate",
          });
          return;
        }
        this.setState({ currentQuestionKey: "question-data-use-monthly" });
        break;
      case "question-data-use-monthly-calculate":
        this.setState({ currentQuestionKey: "question-data-use-monthly" });
        break;
      default:
        break;
    }
  }

  handleQuestionNext(answer) {
    const { currentQuestionKey } = this.state;

    if (currentQuestionKey == null) {
      this.setState({ currentQuestionKey: "question-data-use-monthly" });
      window.trackCustomLink("Online Acq. Select Plan Section | S1_start");
      return;
    }

    // To set the answer for each question
    const answers = this.state.answers;
    answers[currentQuestionKey] = answer;
    this.setState({ answers });

    switch (currentQuestionKey) {
      case "question-data-use-monthly":
        // Less than 10GB​ / 10GB-30GB / >30GB
        if (answer === 0 || answer === 1 || answer === 2) {
          this.setState({
            currentQuestionKey: "question-travel-cnmo",
          });
        }

        // I am not sure
        if (answer === 3) {
          this.setState({
            currentQuestionKey: "question-data-use-monthly-calculate",
          });
        }
        break;
      case "question-travel-cnmo":
        this.showLoadingOffers();
        break;
      case "question-data-use-monthly-calculate":
        this.setState({
          currentQuestionKey: "question-travel-cnmo",
        });
        break;
      default:
        break;
    }
  }

  renderPlanSuggestionCard() {
    const { currentQuestionKey, questions, answers } = this.state;

    const lang = window.THREE_REACT_APP_GLOBAL.language;
    const header =
      lang === "tc"
        ? "唔知揀乜Plan好?"
        : "No idea which plan is the best for you?";
    const subHeader =
      lang === "tc"
        ? "幾個Steps搵出最啱你嘅月費計劃"
        : "Find the monthly plan that suits you best in just a few clicks";

    const labelStart = lang === "tc" ? "立即開始​" : "Let’s Start";

    if (currentQuestionKey == null) {
      return (
        <div className="plan-suggestion-card">
          <div class="container-center">
            <div className="header">{header}</div>
            <div className="sub-header">{subHeader}</div>

            <button
              className="btn-start"
              onClick={() => this.handleQuestionNext()}
            >
              {labelStart}
            </button>
          </div>
          {lang == "tc" ? (
            <div className="container-retention">
              <span class="label-retention">現有客戶而家升級/續約</span>
              <a
                onClick={() =>
                  window.trackCustomLink(
                    "Online Acq. Select Plan Section | S1_rtn"
                  )
                }
                className="btn-outline-transparent"
                href={`${
                  process.env.REACT_APP_THREE_COM_DOMAIN
                }/3Care/chi/MultiOfferOTPLogin.jsp?lang=chi&cid=Retention&cmpid=CAMP00000&intcmp=or3com-homepage`}
              >
                立即Click入嚟睇吓！
              </a>
            </div>
          ) : (
            <div className="container-retention">
              <span class="label-retention">
                Existing customers to upgrade/ renew
              </span>
              <a
                onClick={() =>
                  window.trackCustomLink(
                    "Online Acq. Select Plan Section | S1_rtn"
                  )
                }
                className="btn-outline-transparent"
                href={`${
                  process.env.REACT_APP_THREE_COM_DOMAIN
                }/3Care/eng/MultiOfferOTPLogin.jsp?lang=eng&cid=Retention&cmpid=CAMP00000&intcmp=or3com-homepage`}
              >
                Click here!
              </a>
            </div>
          )}
        </div>
      );
    }

    const question = questions[currentQuestionKey];
    const { type, data } = question;

    if (question == null || type == null) return null;

    if (type === "single-select")
      return (
        <PlanSuggestionQuestionSingleSelect
          data={data}
          answers={answers}
          onQuestionNext={(answer) => this.handleQuestionNext(answer)}
          onQuestionBack={() => this.handleQuestionBack()}
        />
      );

    if (type === "single-slide")
      return (
        <PlanSuggestionQuestionSingleSlider
          data={data}
          onQuestionNext={(answer) => this.handleQuestionNext(answer)}
          onQuestionBack={() => this.handleQuestionBack()}
        />
      );

    if (type === "data-use")
      return (
        <PlanSuggestionQuestionDataUse
          data={data}
          onQuestionNext={(answer) => this.handleQuestionNext(answer)}
          onQuestionBack={() => this.handleQuestionBack()}
        />
      );
  }

  renderLoading() {
    const lang = window.THREE_REACT_APP_GLOBAL.language;
    const header = lang === "tc" ? "請等多一陣" : "Please wait";
    const subHeader =
      lang === "tc"
        ? "謝謝你！我哋正為你選出合適嘅計劃～"
        : "Thank you, we are searching a plan for you";

    return (
      <div className="card-question-general">
        <div className="header">{header}</div>

        <div className="body">
          <div className="sub-header">{subHeader}</div>

          <div class="container-plan-suggestion-spinner">
            <div class="spinner">
              <div class="bar1" />
              <div class="bar2" />
              <div class="bar3" />
              <div class="bar4" />
              <div class="bar5" />
              <div class="bar6" />
              <div class="bar7" />
              <div class="bar8" />
              <div class="bar9" />
              <div class="bar10" />
              <div class="bar11" />
              <div class="bar12" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderOffers() {
    const { answers } = this.state;
    if (answers == null || Object.keys(answers).length === 0) return null;

    return <PlanSuggestionOffers answers={answers} />;
  }

  render() {
    const { status } = this.state;

    return (
      <div className="container-plan-suggestion">
        <div className="plan-suggestion-card-wrapper">
          {status === "answering" && this.renderPlanSuggestionCard()}
          {status === "loading" && this.renderLoading()}
          {status === "showingOffers" && this.renderOffers()}
        </div>
      </div>
    );
  }
}

export default PlanSuggestion;
